<template>
  <div class="input-group input-group-outline mb-3" :class="classObject">
    <i class="icon-text-input" :class="inputType.icon"></i>
    <label class="form-label">{{ label }}</label>
    <template>
      <input
        :type="inputType.type"
        :id="id"
        ref="inputRef"
        class="form-control my-form-control"
        :value="value"
        @input="handleInput"
        @focus="focused = true"
        @blur="focused = false"
        :readonly="isReadOnly"
        :class="classObject"
        :placeholder="placeholder"
      />
    </template>
    <span class="absoluteValue" v-if="value">
      {{ value | limited(50) }}
      <a class="bg-danger" @click="clearInput" title="Remover"><i class="mdi mdi-close"></i></a>
      <a :href="value" target="_blank" class="bg-info" title="Acessar">
        <i class="mdi mdi-link-variant"></i>
      </a>
      <a class="bg-success" title="Copiar" @click="copyToClipboard">
        <i class="mdi mdi-content-copy"></i>
      </a>
    </span>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    icon: { type: Boolean, required: false, default: false },
    value: { type: String, required: false, default: "" },
    id: { type: String, required: false, default: "" },
    label: { type: String, required: false, default: "" },
    placeholder: { type: String, required: false, default: "" },
    autocomplete: { type: String, required: false, default: "" }
  },
  data() {
    return {
      focused: false,
      isReadOnly: true,
      errorMessage: "",
      isInvalid: false
    };
  },
  computed: {
    inputType() {
      return { type: "text", format: "tel", icon: "bx bx-link" };
    },
    classObject() {
      return {
        "focused is-focused": this.focused,
        "is-filled": this.value,
        "input-error": this.isInvalid,
        "value-true": this.value // Adiciona a classe quando houver um value
      };
    },
  },
  methods: {
    ...mapActions(["showMessage"]),  
    handleInput(event) {
      let value = event.target.value;
      const id = event.target.id;
      this.isInvalid = false;
      this.$emit("input", value, id);
    },
    clearInput() {
      this.$emit("input", "", this.id);
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.value);
        this.showMessage({
          title: "Copiado!",
          css: "bg-success"
        });
      } catch (error) {
        console.error("Falha ao copiar texto: ", error);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isReadOnly = false;
    }, 500);
  }
};
</script>

<style scoped>
.icon-text-input {
  position: absolute;
  left: 12px;
  top: 13px;
  z-index: 3;
  font-size: 16px;
  color: #ccc;
}
.form-control {
  padding-left: 40px;
}
input.input-error {
  border: 1px solid red;
}
.my-input-disabled::before {
  position: absolute;
  float: left;
  width: 100%;
  height: 100%;
  background: transparent;
  content: "";
  z-index: 99;
}
.my-input-disabled > input[disabled] {
  background: #f1f2f4;
}
.my-input-disabled > .icon-text-input {
  color: #ccc;
}
.my-input-disabled > label {
  background: -moz-linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(241, 242, 244, 1) 60%
  );
  background: -webkit-linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(241, 242, 244, 1) 60%
  );
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(241, 242, 244, 1) 60%
  );
}
.absoluteValue {
  position: absolute;
  padding: 0px 10px;
  background: #f2f2f2;
  color: #707d8a;
  cursor: pointer;
  top: 1px;
  left: 1px;
  right: 1px;
  z-index: 3;
  border-radius: 5px !important;
  height: 38px;
  line-height: 44px;
}
.absoluteValue > a {
  float: right;
  position: relative;
  width: 30px;
  height: 30px;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  margin-top: 5px;
  text-align: center;
  border-radius: 4px;
  line-height: 30px;
}
.absoluteValue > a + a{
  margin-right: 5px;
}

.value-true {
  background: #f2f2f2;
}
.value-true > label{
  background: linear-gradient( 180deg, rgba(255, 255, 255, 1) 0%, rgba(241, 242, 244, 1) 60% );
}
</style>